export const Products = Object.freeze({
    GENERIC: 'GENERIC',
    AMS: 'AMS',
    PHA: 'PHA',
});

export const BinaryOption = Object.freeze({
    TRUE: 1,
    FALSE: 0,
});

export const ChartTypes = Object.freeze({
    TABLE: 'table',
    BAR: 'bar',
    LINE: 'line',
    PIE: 'pie',
    DOUGHNUT: 'doughnut',
});
